const stateList = [
  "Andhra Pradesh",
  "Arunachal Pradesh",
  "Assam",
  "Bihar",
  "Chhattisgarh",
  "Goa",
  "Gujarat",
  "Haryana",
  "Himachal Pradesh",
  "Jharkhand",
  "Karnataka",
  "Kerala",
  "Madhya Pradesh",
  "Maharashtra",
  "Manipur",
  "Meghalaya",
  "Mizoram",
  "Nagaland",
  "Odisha",
  "Punjab",
  "Rajasthan",
  "Sikkim",
  "Tamil Nadu",
  "Telangana",
  "Tripura",
  "Uttar Pradesh",
  "Uttarakhand",
  "West Bengal",
];

const cityList = {
  "Andhra Pradesh": [
    "Visakhapatnam",
    "Vijayawada",
    "Guntur",
    "Nellore",
    "Kurnool",
    "Kakinada",
    "Rajahmundry",
    "Tirupati",
    "Anantapur",
    "Kadapa",
    "Eluru",
    "Ongole",
    "Vizianagaram",
    "Srikakulam",
    "Chittoor",
    "Machilipatnam",
    "Adoni",
    "Tenali",
    "Proddatur",
    "Hindupur",
  ],
  "Arunachal Pradesh": [
    "Itanagar",
    "Naharlagun",
    "Pasighat",
    "Tawang",
    "Ziro",
    "Bomdila",
    "Roing",
    "Tezu",
    "Daporijo",
    "Aalo",
  ],
  "Assam": [
    "Guwahati",
    "Silchar",
    "Dibrugarh",
    "Jorhat",
    "Nagaon",
    "Tinsukia",
    "Tezpur",
    "Bongaigaon",
    "Dhubri",
    "Diphu",
    "Sivasagar",
    "Goalpara",
    "Lakhimpur",
    "Karimganj",
    "Golaghat",
  ],
  "Bihar": [
    "Patna",
    "Gaya",
    "Bhagalpur",
    "Muzaffarpur",
    "Purnia",
    "Darbhanga",
    "Bihar Sharif",
    "Arrah",
    "Begusarai",
    "Katihar",
    "Munger",
    "Chhapra",
    "Danapur",
    "Saharsa",
    "Sasaram",
    "Hajipur",
    "Dehri",
    "Siwan",
    "Motihari",
    "Nawada",
  ],
  "Chhattisgarh": [
    "Raipur",
    "Bhilai",
    "Korba",
    "Bilaspur",
    "Durg",
    "Rajnandgaon",
    "Raigarh",
    "Jagdalpur",
    "Ambikapur",
    "Mahasamund",
    "Dhamtari",
    "Bemetara",
    "Dongargarh",
    "Kawardha",
    "Manendragarh",
  ],
  "Goa": [
    "Panaji",
    "Margao",
    "Vasco da Gama",
    "Mapusa",
    "Ponda",
    "Bicholim",
    "Curchorem",
    "Quepem",
    "Sanguem",
    "Canacona",
  ],
  "Gujarat": [
    "Ahmedabad",
    "Surat",
    "Vadodara",
    "Rajkot",
    "Bhavnagar",
    "Jamnagar",
    "Junagadh",
    "Gandhinagar",
    "Nadiad",
    "Morbi",
    "Bharuch",
    "Anand",
    "Porbandar",
    "Navsari",
    "Mehsana",
    "Surendranagar",
    "Amreli",
    "Gondal",
  ],
  "Haryana": [
    "Gurugram",
    "Faridabad",
    "Panipat",
    "Ambala",
    "Hisar",
    "Karnal",
    "Rohtak",
    "Yamunanagar",
    "Sonipat",
    "Panchkula",
    "Bhiwani",
    "Sirsa",
    "Bahadurgarh",
    "Jind",
    "Thanesar",
    "Kaithal",
    "Rewari",
  ],
  "Himachal Pradesh": [
    "Shimla",
    "Dharamshala",
    "Mandi",
    "Solan",
    "Palampur",
    "Baddi",
    "Nahan",
    "Chamba",
    "Una",
    "Hamirpur",
    "Kullu",
    "Bilaspur",
    "Kangra",
    "Keylong",
    "Rampur",
    "Sundarnagar",
  ],
  "Jharkhand": [
    "Ranchi",
    "Jamshedpur",
    "Dhanbad",
    "Bokaro",
    "Deoghar",
    "Hazaribagh",
    "Giridih",
    "Ramgarh",
    "Medininagar",
    "Phusro",
    "Gumla",
    "Lohardaga",
    "Simdega",
    "Chaibasa",
    "Dumka",
    "Sahibganj",
    "Jamtara",
    "Chatra",
    "Godda",
    "Pakur",
  ],
  "Karnataka": [
    "Bangalore",
    "Mysore",
    "Mangalore",
    "Hubli",
    "Belgaum",
    "Davanagere",
    "Ballari",
    "Vijayapura",
    "Shivamogga",
    "Tumakuru",
    "Raichur",
    "Bidar",
    "Hassan",
    "Bagalkot",
    "Gulbarga",
    "Chitradurga",
    "Kolar",
    "Mandya",
    "Chikkamagaluru",
    "Udupi",
    "Ramanagara",
  ],
  "Kerala": [
    "Thiruvananthapuram",
    "Kochi",
    "Kozhikode",
    "Kollam",
    "Thrissur",
    "Kannur",
    "Alappuzha",
    "Palakkad",
    "Kottayam",
    "Malappuram",
    "Kasaragod",
    "Idukki",
    "Pathanamthitta",
    "Wayanad",
  ],
  "Madhya Pradesh": [
    "Bhopal",
    "Indore",
    "Gwalior",
    "Jabalpur",
    "Ujjain",
    "Sagar",
    "Dewas",
    "Satna",
    "Ratlam",
    "Rewa",
    "Murwara",
    "Singrauli",
    "Burhanpur",
    "Chhindwara",
    "Khargone",
    "Khandwa",
    "Bhind",
    "Shivpuri",
    "Vidisha",
    "Chhatarpur",
    "Pithampur",
  ],
  "Maharashtra": [
    "Mumbai",
    "Pune",
    "Nagpur",
    "Nashik",
    "Aurangabad",
    "Solapur",
    "Thane",
    "Amravati",
    "Kolhapur",
    "Akola",
    "Jalgaon",
    "Latur",
    "Nanded",
    "Dhule",
    "Ahmednagar",
    "Chandrapur",
    "Parbhani",
    "Ichalkaranji",
    "Sangli",
    "Jalna",
  ],
  "Manipur": [
    "Imphal",
    "Thoubal",
    "Bishnupur",
    "Churachandpur",
    "Senapati",
    "Ukhrul",
    "Tamenglong",
    "Kakching",
    "Moirang",
    "Jiribam",
  ],
  "Meghalaya": [
    "Shillong",
    "Tura",
    "Nongstoin",
    "Jowai",
    "Baghmara",
    "Williamnagar",
    "Mairang",
    "Resubelpara",
    "Nongpoh",
    "Mawkyrwat",
  ],
  "Mizoram": [
    "Aizawl",
    "Lunglei",
    "Saiha",
    "Champhai",
    "Kolasib",
    "Serchhip",
    "Mamit",
    "Lawngtlai",
    "Bairabi",
    "Tlabung",
  ],
  "Nagaland": [
    "Kohima",
    "Dimapur",
    "Mokokchung",
    "Wokha",
    "Tuensang",
    "Mon",
    "Zunheboto",
    "Phek",
    "Kiphire",
    "Longleng",
  ],
  "Odisha": [
    "Bhubaneswar",
    "Cuttack",
    "Rourkela",
    "Sambalpur",
    "Berhampur",
    "Puri",
    "Balasore",
    "Baripada",
    "Bargarh",
    "Jharsuguda",
    "Kendujhar",
    "Bhadrak",
    "Jeypore",
    "Angul",
    "Sonepur",
  ],
  "Punjab": [
    "Chandigarh",
    "Ludhiana",
    "Amritsar",
    "Jalandhar",
    "Patiala",
    "Bathinda",
    "Mohali",
    "Hoshiarpur",
    "Pathankot",
    "Moga",
    "Batala",
    "Firozpur",
    "Phagwara",
    "Abohar",
    "Malerkotla",
  ],
  "Rajasthan": [
    "Jaipur",
    "Udaipur",
    "Jodhpur",
    "Kota",
    "Ajmer",
    "Bikaner",
    "Bharatpur",
    "Alwar",
    "Pali",
    "Sikar",
    "Tonk",
    "Beawar",
    "Chittorgarh",
    "Bhilwara",
    "Sawai Madhopur",
  ],
  "Sikkim": [
    "Gangtok",
    "Namchi",
    "Gyalshing",
    "Rangpo",
    "Mangan",
    "Singtam",
    "Jorethang",
    "Pelling",
    "Soreng",
    "Chungthang",
  ],
  "Tamil Nadu": [
    "Chennai",
    "Coimbatore",
    "Madurai",
    "Tiruchirappalli",
    "Salem",
    "Tiruppur",
    "Erode",
    "Vellore",
    "Thoothukudi",
    "Dindigul",
    "Thanjavur",
    "Nagercoil",
    "Tirunelveli",
    "Cuddalore",
    "Kanchipuram",
    "Karur",
    "Hosur",
    "Sivakasi",
    "Nagapattinam",
    "Viluppuram",
  ],
  "Telangana": [
    "Hyderabad",
    "Warangal",
    "Nizamabad",
    "Karimnagar",
    "Ramagundam",
    "Khammam",
    "Mahbubnagar",
    "Nalgonda",
    "Adilabad",
    "Siddipet",
    "Suryapet",
    "Miryalaguda",
    "Jagtial",
    "Kamareddy",
    "Bodhan",
    "Mancherial",
    "Wanaparthy",
    "Kothagudem",
    "Palwancha",
  ],
  "Tripura": [
    "Agartala",
    "Dharmanagar",
    "Kailashahar",
    "Udaipur",
    "Kumarghat",
    "Amarpur",
    "Bishalgarh",
    "Belonia",
    "Khowai",
    "Teliamura",
  ],
  "Uttar Pradesh": [
    "Lucknow",
    "Kanpur",
    "Ghaziabad",
    "Agra",
    "Varanasi",
    "Meerut",
    "Prayagraj",
    "Noida",
    "Aligarh",
    "Moradabad",
    "Bareilly",
    "Saharanpur",
    "Gorakhpur",
    "Firozabad",
    "Jhansi",
    "Rampur",
    "Shahjahanpur",
    "Faizabad",
    "Muzaffarnagar",
    "Mathura",
    "Budaun",
    "Lakhimpur",
    "Sitapur",
    "Mau",
    "Fatehpur",
    "Etawah",
    "Ballia",
    "Jaunpur",
    "Deoria",
    "Unnao",
  ],
  "Uttarakhand": [
    "Dehradun",
    "Haridwar",
    "Roorkee",
    "Haldwani",
    "Rudrapur",
    "Kashipur",
    "Rishikesh",
    "Kotdwara",
    "Ramnagar",
    "Pithoragarh",
    "Mussoorie",
    "Nainital",
    "Almora",
    "Bageshwar",
    "Chamoli",
  ],
  "West Bengal": [
    "Kolkata",
    "Asansol",
    "Siliguri",
    "Durgapur",
    "Howrah",
    "Bardhaman",
    "Malda",
    "Berhampore",
    "Kharagpur",
    "Haldia",
    "Naihati",
    "Krishnanagar",
    "Srirampur",
    "Barrackpore",
    "Ranaghat",
    "Jalpaiguri",
    "Bansberia",
    "Cooch Behar",
    "Darjeeling",
  ],
};

export {stateList, cityList}